import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as userActions from '@/store/actions/user';
import * as boxActions from '@/store/actions/selectBox';
import { Icon, Select, Form, Button, Input, InputNumber, Row, Col, Cascader, DatePicker, Radio, message } from 'antd';
import { getOrgList_box, addLab, addOrg, getDataList_box, getLinkGroupList, getPiListlab, reqByGet } from '@/api/api';
import servers from '@/api/server'
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/date-picker/locale/zh_CN';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { TextArea } = Input;


const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}

function dateHourPicker() {
    return {
        disabledMinutes: () => range(0, 60),
        disabledSeconds: () => range(0, 60),
    };
}

class Filter extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            orgBoxList: props.selectBox.orgBox,
            medicineClassify: props.medicineClassify ? props.medicineClassify : [],
            yearPickerOpen: false,
            fenleiList: [],
            num: props.num,
            // formItems: props.formItems || [],
            piList: props.piList ? props.piList : []
        }
        this.formSubmit = this.formSubmit.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        const that = this
        console.log(nextProps)
        console.log(this.state.num)
        const { num } = this.state
        if (!nextProps.num) {
            return
        }
        const nextNum = nextProps.num.toString()
        if (num.toString() !== nextNum) {
            this.setState({
                num: nextProps.num,
            }, () => {
                reqByGet(servers.getEqclassify, { isMeeting: num > 100 ? 1 : 0 }, res => {
                    console.log(res)
                    that.setState({
                        fenleiList: res.data
                    })
                }, err => {
                    console.log(err)
                })
            })
        }
    }
    componentDidMount() {
        const that = this;
        this.props.formItems.map(x => {
            if (x.type && x.type === 'medicine_type') {
                console.log('medicine_type')
                getDataList_box({ typeId: 8 }, res => {//获取试剂耗材分类
                    console.log(res)
                    that.props.medicineClassify_input(res.objList)
                }, err => {
                    console.log(err)
                })
            }
            if (x.type && x.type === 'linkgroup_type') {
                console.log('linkgroup_type')
                getLinkGroupList({}, res => { //获取联系人类型下拉列表
                    console.log(res)
                    that.props.group_input(res.groupList)
                }, err => {
                    console.log(err)
                })
            }
            if (x.type && x.type === 'selectClassify') {
                reqByGet(servers.getEqclassify, { isMeeting: x.isMeeting }, res => {
                    console.log(res)
                    this.setState({
                        fenleiList: res.data
                    })
                }, err => {
                    console.log(err)
                })
            }
            if (x.type && x.type === 'memberPi_select') {
                console.log('memberPi_select')
                getPiListlab({}, res => { //获取课题组下拉列表
                    console.log(res)
                    that.props.piList_input(res.list)
                }, err => {
                    console.log(err)
                })
            }
            if (x.type && x.type === 'orgBox') {
                getOrgList_box({}, res => { //获取机构下拉列表
                    that.props.org_input(res.orgBoxList)
                }, err => {
                    console.log(err)
                })
            };
        })

    }

    formSubmit(e) {
        const that = this;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values)
            if (!err) {
                let params = {};
                for (let key in values) {
                    if (values[key] || values[key] === 0) {
                        params[key] = values[key];
                    }
                };
                this.props.dataFilter(params)
            }
        });
    }

    render() {
        const that = this;
        const { formItems, selectBox } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { medicineClassify, orgBoxList, yearPickerOpen, piList, fenleiList } = this.state;
        const formType = (item) => {
            // const item=props.item;
            if (item.type === 'orgBox') {
                return (
                    <Select placeholder="--请选择--" style={{ width: item.width ? item.width : 'auto' }} >
                        {orgBoxList.map(x => {
                            return (
                                <Option value={x.id} key={x.id}>{x.orgName}</Option>
                            )
                        })}
                    </Select>
                )
            } else if (item.type === 'number') {
                return (<InputNumber disabled={item.disabled && item.disabled} max={item.max && item.max} />)
            } else if (item.type === 'rangePicker') {
                return (
                    <RangePicker showTime={item.showTime || false} style={{ width: item.width ? item.width : '411px' }} placeholder={['开始时间', '结束时间']} />
                )
            } else if (item.type === 'monthPicker') {
                return (
                    <MonthPicker style={{ width: '160px' }} placeholder={item.placeholder} />
                )
            } else if (item.type === 'weekPicker') {
                return (
                    <WeekPicker style={{ width: '160px' }} placeholder={item.placeholder} />
                )
            } else if (item.type === 'yearPicker') {
                return (
                    <DatePicker
                        style={{ width: '140px' }}
                        placeholder={item.placeholder}
                        mode='year'
                        format='YYYY'
                        open={yearPickerOpen}
                        onOpenChange={open => {
                            that.setState({
                                yearPickerOpen: open
                            })
                        }}
                        onPanelChange={(value, mode) => {
                            that.props.form.setFieldsValue({ [item.key]: value });
                            that.setState({
                                yearPickerOpen: false
                            })
                        }}
                    />
                )
            } else if (item.type === 'status') {
                return (
                    <Select style={{ width: 120 }} placeholder={item.placeholder}>
                        <Option value="">全部</Option>
                        <Option value="10">启用</Option>
                        <Option value="20">禁用</Option>
                    </Select>
                )
            } else if (item.type === 'datePicker') {
                return (
                    <DatePicker placeholder={item.placeholder ? item.placeholder : '选择日期'} locale={locale} />
                )
            } else if (item.type === 'dateTimePicker') {
                return (
                    <DatePicker
                        placeholder={item.placeholder ? item.placeholder : '选择时间'}
                        showTime={true}
                        locale={locale}
                    />
                )
            } else if (item.type === 'dateHourPicker') {
                return (
                    <DatePicker
                        placeholder={item.placeholder ? item.placeholder : '选择时间'}
                        showTime={true}
                        locale={locale}
                    // disabledTime={item.disabledDateTime}
                    />
                )
            } else if (item.type === 'medicine_numAlarm') {
                return (
                    <Select style={{ width: 120 }} placeholder={item.placeholder}>
                        <Option value="">全部</Option>
                        <Option value={2}>正常</Option>
                        <Option value={1}>缺货</Option>
                    </Select>

                )
            }
            else if (item.type === 'docType') {
                return (
                    <Select style={{ width: 120 }} placeholder={item.placeholder}>
                        <Option value="">全部</Option>
                        <Option value={10}>文献资料</Option>
                        <Option value={11}>汇报</Option>
                        <Option value={15}>其它</Option>
                    </Select>

                )
            } else if (item.type === 'flow_status') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder}>
                        <Option value="">全部</Option>
                        <Option value={1}>审批中</Option>
                        <Option value={2}>审批通过</Option>
                        <Option value={3}>审批被拒</Option>
                    </Select>
                )
            } else if (item.type === 'autidType_buy') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder}>
                        <Option value="10">待审批</Option>
                        <Option value="20">审批通过-待入库</Option>
                        <Option value="30">审批通过-已入库</Option>
                        <Option value="40">申领失败</Option>
                    </Select>
                )
            } else if (item.type === 'instumentStatus') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder}>
                        <Option value=''>全部</Option>
                        <Option value={1}>正常</Option>
                        <Option value={3}>维修中</Option>
                        <Option value={2}>外借中</Option>
                        <Option value={4}>已报废</Option>
                    </Select>
                )
            } else if (item.type === 'auditStatus') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder}>
                        <Option value=''>全部</Option>
                        <Option value={'1'}>审核中</Option>
                        <Option value={'2'}>审核通过</Option>
                        <Option value={'3'}>审核被拒</Option>
                        <Option value={'9'}>待确认</Option>
                    </Select>
                )
            } else if (item.type === 'memberInOut_select') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value='all'>全部</Option>
                        <Option value='0'>内部人员 </Option>
                        <Option value='1'>外部人员</Option>
                    </Select>
                )
            } else if (item.type === 'memberPi_select') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value='all'>全部</Option>
                        {selectBox.piListBox && selectBox.piListBox.map(x => {
                            return (
                                <Option value={x.id} key={x.id}>{x.name}</Option>
                            )
                        })}
                        <Option value='wu'>未分配课题组</Option>
                    </Select>
                )
            } else if (item.type === 'selectClassify') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value=''>全部</Option>
                        {fenleiList && fenleiList.map(x => {
                            return (
                                <Option value={x} key={x}>{x}</Option>
                            )
                        })}
                    </Select>
                )
            } else if (item.type === 'memberType_select') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value='all'>全部</Option>
                        <Option value='1'>学生 </Option>
                        <Option value='2'>合同制</Option>
                        <Option value='3'>在编人员</Option>
                    </Select>
                )
            } else if (item.type === 'medicine_type') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value=''>全部</Option>
                        {selectBox.medicineClassifyBox && selectBox.medicineClassifyBox.map(x => {
                            return (
                                <Option value={x.id} key={x.id}>{x.name}</Option>
                            )
                        })}
                    </Select>
                )
            } else if (item.type === 'linkgroup_type') {
                return (
                    <Select style={{ width: 140 }} placeholder={item.placeholder} >
                        <Option value=''>全部</Option>
                        {
                            selectBox.linkGroupBox.map(x => {
                                console.log(x.groupName);
                                return (
                                    <Option value={x.id} key={x.id}>{x.groupName}</Option>
                                )
                            })}
                    </Select>
                )
            } else if (item.type === 'select') {
                return (
                    <Select style={{ width: item.width ? item.width : 140 }} placeholder={item.placeholder} dropdownClassName='f13'>
                        {!!item.allOption && <Option value=''>全部</Option>}
                        {
                            item.options.map(x => {
                                return (
                                    <Option value={x.value} key={x.value}>{x.name}</Option>
                                )
                            })}
                    </Select>
                )
            }

            return (
                <Input placeholder={item.placeholder} style={{ width: item.width ? item.width : 'auto' }} autoComplete="off" disableautocomplete='true' />
            )
        };
        return (
            <Form layout="inline" onSubmit={this.formSubmit} className="tabelfilter_form">
                {formItems.map(x => {
                    let validate = {};
                    if (x.validate) {
                        validate = x.validate
                    }
                    return (
                        <FormItem key={x.key}>
                            {getFieldDecorator(`${x.key}`, validate)(
                                formType(x)
                            )}
                        </FormItem>
                    )
                })}
                <FormItem>
                    <Button className='ml0' htmlType="submit" style={{ padding: '0 7px', lineHeight: "1.399" }}><i className='iconfont icon-sousuo'></i></Button>
                </FormItem>
            </Form>
        )
    }
}

const FilterForm = Form.create({})(Filter);

function mapStateToProps(state) {
    return {
        user: state.user,
        selectBox: state.selectBox
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ ...userActions, ...boxActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterForm);

// export default FilterForm